
import api from '~api'
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XAddress from 'vux/src/components/x-address/index.vue'
import ChinaAddressData from 'vux/src/datas/china_address.json'
import Datetime from 'vux/src/components/datetime/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

export default {
name: "militaryTrainingClothing",
components: {
XHeader,Group,Cell,XAddress,Datetime,Selector,XTextarea,XInput,XButton
},
data(){
return{
title: "军训服装",
formdata:[],
co:'',
remark: "",
colourName: "",
colors:[],
list: [],
detail: [],
isOk: false,
sub:'提交'
}
},
mounted(){
this.getDetail()
},
methods:{
getDetail(){
let data = [];
let _this = this
api.post("/api/uniSele/selebystu", {"stuCode": window.localStorage.getItem('stuCode')}).then( res=>{
if(res.status==200){
if(res.data.data.length>0 ){
if(res.data.data[0].receiveStatus==='0'){
_this.getData1(res.data.data)
_this.getColor()
_this.detail = res.data.data
_this.co = res.data.data[0].color
_this.remark = res.data.data[0].remark
_this.colourName = res.data.data[0].colourName
_this.sub = '修改'
_this.isOk=true
}else {
_this.detail = res.data.data
_this.remark = res.data.data[0].remark
_this.colourName = res.data.data[0].colourName
_this.isOk=false
}
}else {
_this.getData()
_this.getColor()
_this.isOk=true
}
}else {
_this.$msgbox('温馨提示：',"服务器异常请稍后再试");
}
})
},
getData1(dat){
let data = [];
let _this = this
api.post("/api/uniSele/sele").then( res=>{
console.log(32311111,res)
if(res.status==200){
if(res.data){
if (res.data.data.length>0){
res.data.data.map((item)=>{
let arr = [];
item.uniformSeletedEntity.map((items)=>{
arr.push({
key:items.id,

value:`${items.size}    ${items.remark}`
})
})
data.push({
typeName:item.typeName,
id:item.id,
uniformSeletedEntity:arr
})
})
_this.list =data



for(var i =0;i < res.data.data.length;i++){
for (var j =0; j < dat.length;j++){
if(res.data.data[i].typeName===dat[j].typeName){
_this.formdata[i] = dat[j].uniformSizeId
}
}
}
}else {
_this.$msgbox('温馨提示：',"暂无数据");
}
}else {
_this.$msgbox('温馨提示：',"暂无数据");
}
}else {
_this.$msgbox('温馨提示：',"服务器异常请稍后再试");
}
})
},
getData(){
let data = [];
let _this = this
api.post("/api/uniSele/sele").then( res=>{
if(res.status==200){
if(res.data){
if (res.data.data.length>0){
res.data.data.map((item)=>{
let arr = [];
item.uniformSeletedEntity.map((items)=>{
console.log(222222,items)
arr.push({
key:items.id,

value:`${items.size}    ${items.remark}`
})
})
data.push({
typeName:item.typeName,
id:item.id,
uniformSeletedEntity:arr
})
})
_this.list =data
}else {
_this.$msgbox('温馨提示：',"暂无数据");
}
}else {
_this.$msgbox('温馨提示：',"暂无数据");
}
}else {
_this.$msgbox('温馨提示：',"服务器异常请稍后再试");
}
})
},
getColor(){
let data = [];
let _this = this
api.post("/api/uniSele/colo").then( res=>{
if(res.status==200){
if(res.data){
if (res.data.data.length>0){
let arr = [];
res.data.data.map((items)=>{
arr.push({
key:items.color,
value:items.colourName
})
})
_this.colors = arr
}else {
_this.$msgbox('温馨提示：',"暂无数据");
}
}else {
_this.$msgbox('温馨提示：',"暂无数据");
}
}else {
_this.$msgbox('温馨提示：',"服务器异常请稍后再试");
}
})
},
add(){
let _this = this
if(_this.sub==='修改'){
console.log(_this.formdata)
if(this.formdata.length!==this.list.length){
_this.$msgbox('温馨提示：',"请选择服饰尺寸");
}else if(this.co==='') {
_this.$msgbox('温馨提示：',"请选择颜色");
}else {
var parms = [];
this.formdata.map((item)=>{
parms.push({
stuCode:window.localStorage.getItem("stuCode"),
uniformSizeId:item,
color:this.co,
remark:this.remark
})
})
console.log(parms)
api.post("/api/uniSele/updateStuForm", {'formList':parms,"stuCode":window.localStorage.getItem("stuCode"),}).then( res=>{
if(res.status==200){
_this.$msgbox('温馨提示：',"修改成功");
_this.goNext();
}else {
_this.$msgbox('温馨提示：',"服务器异常请稍后再试");
}
})
}
}else {
if(this.formdata.length!==this.list.length){
_this.$msgbox('温馨提示：',"请选择服饰尺寸");
}else if(this.co==='') {
_this.$msgbox('温馨提示：',"请选择颜色");
}else {
var parms = [];
this.formdata.map((item)=>{
parms.push({
stuCode:window.localStorage.getItem("stuCode"),
uniformSizeId:item,
color:this.co,
remark:this.remark
})
})
api.post("/api/uniSele/add", {'formList':parms}).then( res=>{
if(res.status==200){
_this.$msgbox('温馨提示：',"添加成功");
_this.getDataPro();
}else {
_this.$msgbox('温馨提示：',"服务器异常请稍后再试");
}
})
}
}
},
getDataPro(){
const _this = this;
api.post("/api/proces/findProcess", {"stuCode": window.localStorage.getItem("stuCode"),"enrollType": window.localStorage.getItem("enrollType")}).then( res=>{
if(res.status==200){
for(var i=0;i<res.data.results.length;i++){
var item = {
"sort":res.data.results[i].processId,
"title":res.data.results[i].moduleName,
"urlname":res.data.results[i].urlName,
"skip":res.data.results[i].skip
}
if(res.data.results[i].newStatus=='0'){
item["okflag"] = false;
}else{
item["okflag"] = true;
}

if( window.localStorage.getItem('grade')==(new Date().getFullYear()).toString()){
_this.flowdata.push(item);
}else{
if(res.data.results[i].moduleName=="缴费信息" || res.data.results[i].moduleName=="缴费详情" ){
_this.flowdata.push(item);
}
}
}
const data =_this.flowdata;
const d = data.filter(item=> !item.okflag)
if(d.length>0){
const ite = d.filter(items=> items.title === '缴费信息')
if(ite.length>0){
if(ite[0].title!=='缴费信息'){
api.post('/api/NewReports/addStatus',{"stuCode": window.localStorage.getItem("stuCode"),"processId":ite[0].sort})
.then(function (response) {
if(response.data.results){
_this.goNext()
}
})
}else {
_this.goNext()
}
}else {
_this.goNext()
}
}else {
_this.goNext()
}
}
})
},
goNext () {
var _this = this;
var flowdata = JSON.parse(window.localStorage.getItem('flowdata'));
var sort = _this.$route.params.sort;
var urlname = '';
var stunum = _this.$route.params.stunum;
for (var i = 0;i<flowdata.length;i++){
if(flowdata[i].sort>sort){
sort = flowdata[i].sort;
urlname = flowdata[i].urlname;
_this.$router.push({name: urlname,params:{sort:sort,stunum:stunum,skip:flowdata[i].skip}});
return;
}/*else{
_this.$router.push({name: 'generateform',params:{stunum:stunum}});
}*/
}
},
}
}



// WEBPACK FOOTER //
// ./src/components/militaryTrainingClothing.vue